import { translateDataToTree, responseFormat } from '@/utils'
import { UPDATE_TOKEN, UPDATE_USER_INFO, UPDATE_PERMISSIONS, SET_PAGE_CACHE, UPDATE_SELECT } from './mutation-types'
export default {
  [UPDATE_TOKEN]: (state, payload) => {
    state.token = payload
  },
  [UPDATE_USER_INFO]: (state, payload) => {
    state.userInfo = payload
  },
  [UPDATE_PERMISSIONS]: (state, payload = []) => {
    // 找出前台权限项
    const current = responseFormat.string2number(payload, ['parent_id'], true).filter(item => item.type === '1' && (!item.project || item.project === 'bzmj'))
    const permissions = []
    const operateAuth = []
    const bzmj = []
    for (let item of current) {
      if (item.project && item.project !== 'bzmj') continue
      if (item.uri) {
        permissions.push(item.uri)
        if (item.project === 'bzmj') {
          bzmj.push(item)
        }
      } else if (item.prop) {
        operateAuth.push(item.prop)
      }
    }
    state.allPermissions = current
    // 路由权限
    state.permissions = permissions
    // 操作权限
    state.operateAuth = operateAuth

    state.routes = translateDataToTree(bzmj)
  },
  updateSelect (state, payload) {
    state.commonSelect = payload
  },
  // 设置页面缓存
  [SET_PAGE_CACHE] (state, payload) {
    state.cached = payload
  },
  [UPDATE_SELECT.BUSINESS_TYPE] (state, payload) {
    state.businessTypes = payload.reduce((obj, { label, value }) => {
      if (value) {
        obj[value] = label
      }
      return obj
    }, {})
  },
  [UPDATE_SELECT.CHILD_TASK_TYPE] (state, payload) {
    state.childTaskTypes = payload.reduce((obj, { label, value }) => {
      if (value) {
        obj[value] = label
      }
      return obj
    }, {})
  },
  [UPDATE_SELECT.ABNORMAL_CATEGORY] (state, payload) {
    state.abnormalTypes = payload.reduce((obj, { label, value }) => {
      if (value) {
        obj[value] = label
      }
      return obj
    }, {})
  }
}
